import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function uploadFile(files) {
    let data = new FormData();
    data.append('file_upload', files['file']);
    data.append('submission', files['submission_id']);
    data.append('assignment_updated', files['assignment_updated']);

    if (files['assignment_filename_id'] && files['assignment_filename_id'] > 0) {
        data.append('assignment_filename', files['assignment_filename_id']);
    }

    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/submission_files`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "POST";
    baseRequestConfig.body = (data);

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function removeFile(fileId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/submission_files/${fileId}`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "DELETE";

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function downloadFile(fileId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/submission_files/${fileId}/download`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "GET";
    baseRequestConfig.headers['content-type'] = 'application/octet-stream';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.blob();
}


/** WEBPACK FOOTER **
 ** ./src/connectivity/api.files.js
 **/